import { render } from "./RegisterCompanyPhone.vue?vue&type=template&id=cbd1ef26"
import script from "./RegisterCompanyPhone.vue?vue&type=script&lang=js"
export * from "./RegisterCompanyPhone.vue?vue&type=script&lang=js"

import "./RegisterCompanyPhone.vue?vue&type=style&index=0&id=cbd1ef26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__